export enum articlesRecruiterTypes {
  FETCH_ARTICLES_RECRUITER_REQUEST = "FETCH_ARTICLES_RECRUITER_REQUEST",
  FETCH_ARTICLES_RECRUITER_SUCCESS = "FETCH_ARTICLES_RECRUITER_SUCCESS",
  FETCH_ARTICLES_RECRUITER_FAILURE = "FETCH_ARTICLES_RECRUITER_FAILURE",
}